export const paths = {
  solarPanels: {
    en: '/solar-panels/',
    es: '/placas-solares/',
  },
  solarPanelsSpain: {
    es: '/placas-solares/espana/',
  },
  solarPanelsInstallation: {
    en: '/solar-panels/installation/',
    es: '/placas-solares/instalacion/',
  },
  solarPanelsBattery: {
    en: '/solar-panels/battery/',
    es: '/placas-solares/bateria/',
  },
  solarPanelsHomes: {
    en: '/solar-panels/homes/',
    es: '/placas-solares/casas/',
  },
  solarPanelsCompanies: {
    en: '/solar-panels/companies/',
    es: '/placas-solares/empresas/',
  },
  solarPanelsCommunities: {
    en: '/solar-panels/communities/',
    es: '/placas-solares/comunidades-vecinos/',
  },
  solarPayback: {
    en: '/payback/',
    es: '/amortizacion/',
  },
  solarSelfConsumption2: {
    en: '/solar-self-consumption/',
    es: '/blog/precio-para-instalar-un-sistema-de-placas-solares/',
  },
  solarCalculator: {
    en: '/solar-calculator/',
    es: '/calculadora-solar/',
  },
  subsidies: {
    en: '/subsidies/',
    es: '/subvenciones/',
  },
  financing: {
    en: '/financing/',
    es: '/financiacion/',
  },
  blog: {
    es: '/blog/',
    en: '/blog/',
  },
  commercial: {
    es: '/placas-solares/empresas/',
    en: '/solar-panels/companies/',
  },
  heatPumps: {
    es: '/aerotermia/',
    en: '/aerothermia/',
  },
  evChargers: {
    es: '/cargadores-electricos/',
    en: '/ev-chargers/',
  },
  blockOfFlats: {
    es: '/placas-solares/comunidades-vecinos/',
    en: '/solar-panels/communities/',
  },
  newsroom: {
    en: '/newsroom/',
    es: '/sala-de-prensa/',
  },
  careers: {
    en: 'https://solar.sunhero.com/en/careers/',
    es: 'https://solar.sunhero.com/es/careers/',
  },
  virtualBatteries: {
    en: '/solar-self-consumption/virtual-batteries/',
    es: '/autoconsumo-solar/baterias-virtuales/',
  },
  warranties: {
    en: '/warranty/',
    es: '/garantia/',
  },
  ambassadorPlus: {
    en: '/ambassador-plus/',
    es: '/embajador-plus/',
  },
  navTechnicalSupport: {
    en: '/technical-support/',
    es: '/soporte-tecnico/',
  },
};
